<script>
  import { onMount, onDestroy } from "svelte";
  import PlayCoverSpin from "./PlayCoverSpin.svelte";

  export let id;
  export let coverRefs;
  export let imgSrc;
  export let size = "100%";

  let ref;

  onMount(() => {
    coverRefs[id] = ref;
  });

  onDestroy(() => {
    delete coverRefs[id];
  });
</script>

<PlayCoverSpin bind:this={ref} {imgSrc} {size} />